<!--
  ~ Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
  ~ Unauthorised copying of this file, via any medium is strictly prohibited
  ~ Proprietary and confidential
  ~ Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
  ~
  -->

    <acabim-datatable
        #dataTable
        [dataSources]="[this]"
        [dataKey]="'id'"
        [helpMessage]="helpMessage"
        [hasDetailView]="true">
    </acabim-datatable>
    <div class="cas-action-buttons">
        <button type='button' class="cas-button-action" data-cy="_t-add-site-start" (click)="onAddSite()">Add site</button>
    </div>

<acabim-modal
    [title]="archiveCardTitle"
    [display]="displayArchiveModal"
    (status)="setModal($event)"
    [footer]="false">
    <div *ngIf="!isLoading else loadingView">
        <div class="p-d-flex flex-column">
            <div class="p-d-flex flex-row">
                <p>Do you really want to archive these sites: </p>
            </div>
            <div class="p-d-flex flex-row">
                <acabim-data-display [dataMap]="archivedSiteData" labelWidth="20rem"></acabim-data-display>
            </div>
        </div>
        <div class="cas-action-buttons">
            <button (click)="archiveAction(true)" class="cas-button-action">Archive</button>
            <button (click)="archiveAction(false)">Cancel</button>
        </div>
    </div>
</acabim-modal>


<acabim-modal
        [title]="'Add a new site'"
        [display]="displayAddModal"
        (status)="setAddModal($event)"
        [footer]="false"
        width="80vw"
        fixHeight="80vh">
    <acabim-admin-add-site (completed)="handleAddModal($event)"></acabim-admin-add-site>
</acabim-modal>

<acabim-modal
    [title]="'Add sites to groups'"
    [display]="displayGroupModal"
    (status)="setGroupModal($event)"
    [footer]="false"
    width="80vw"
    fixHeight="80vh">
    <acabim-admin-assign-site-groups [siteDetails]="this.selectedData" (completed)="siteGroupAction($event)"></acabim-admin-assign-site-groups>
</acabim-modal>

<acabim-modal
        [display]="showDetails"
        [title]="'Edit site details'"
        (status)="setEditModal($event)"
        [footer]="false"
        width="80vw"
        [showTooltip]="false"
        fixHeight="80vh">
    <acabim-admin-edit-site *ngIf="showDetails" [_currentSite]="detailData"
                            (closeDialog)="Close($event)"></acabim-admin-edit-site>
</acabim-modal>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<p-toast position="center"></p-toast>
